import type { GroupedStage } from 'src/pages/jobs/organisms/job-workflows/types';

import { createAction } from '@reduxjs/toolkit';

export interface WorkFlowStages {
    WorkFlowStages: Record<string, GroupedStage[]>;
}

export const initialState: WorkFlowStages = {
    WorkFlowStages: {},
}

export const setWorkFlowStages = createAction<Record<string, GroupedStage[]>>('jobWorkFlow/setWorkFlowStages');